import constants from './../utils/constants';
import { IUser } from '@/models/User';

export interface State {
  currentUser: IUser | null;
  isMaster: boolean;
  callingAPI: boolean;
  perPageOptions: Array<number>;
  defaultPerPage: number;
  userPagePermission: string;
  autoPrint: { outletCode: string; interval: number; } | null;
  isEDC: boolean;
}

export const state: State = {
  currentUser: null,
  isMaster: false,
  callingAPI: false,
  perPageOptions: [10, 20, 50, 100],
  defaultPerPage: 20,
  userPagePermission: constants.PERMISSION_N,
  autoPrint: null,
  isEDC: false,
};

export default state;
